var map = {
	"./icon_1.png": 3984,
	"./icon_10.png": 3202,
	"./icon_11.png": 4331,
	"./icon_12.png": 3040,
	"./icon_2.png": 9019,
	"./icon_3.png": 18,
	"./icon_4.png": 1581,
	"./icon_5.png": 9076,
	"./icon_6.png": 2639,
	"./icon_7.png": 902,
	"./icon_8.png": 2385,
	"./icon_9.png": 6088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;